import React from 'react'
import EditableComponent from './EditableComponent'
import getEnumTranslation from '@/enums/enums'
import { DropDownList } from '@/components/dropDownList'
import OffsetInput from './OffsetInput'
import { DueDateWeekly, VALUES } from '@/enums/DueDateWeekly'
import { Col, Row } from 'reactstrap'

class EnumBasePicker extends EditableComponent {
  getEnumName () { return null } // to be overriden
  getEnumValues () { return null } // to be overriden

  renderSelectorDropDownList (data) {
    return (<DropDownList
      disabled={this.props.disabled}
      data={data}
      onChange={({ value }) => this.props.onIntValueChange(value)}
      value={this.props.intValue}
      textField='text'
      valueField='value' />)
  }
  renderWeekDayDropDownList (data) {
    return (<DropDownList
      disabled={this.props.disabled}
      data={data}
      onChange={({ value }) => this.props.onOffsetChange(value)}
      value={this.props.offset}
      textField='text'
      valueField='value' />)
  }
  renderControl () {
    const { localize, intValue } = this.props
    const enumName = this.getEnumName()
    if (this.isEdited()) {
      const weekDaysData = this.getEnumValues().map(x => ({ text: getEnumTranslation({ localize, enumName, value: x }), value: x.toString() }))

      if (this.props.isDueDate) {
        const renderOffset = intValue === DueDateWeekly.OFFSET
        const data = VALUES.map(x => ({ text: getEnumTranslation({ localize, enumName: 'DueDateWeekly', value: x }), value: x }))

        return (<Row className='f1'>
          <Col sm='6'>{this.renderSelectorDropDownList(data)}</Col>
          <Col sm='6'>{renderOffset && <OffsetInput disabled={this.props.disabled} value={this.props.offset} onChange={offset => this.props.onOffsetChange(offset)} />}
            {!renderOffset && this.renderWeekDayDropDownList(weekDaysData)}</Col>
        </Row>)
      } else {
        return this.renderWeekDayDropDownList(weekDaysData)
      }
    }
    let text
    if (!this.props.isDueDate || this.props.intValue === DueDateWeekly.WEEK_DAY) {
      text = getEnumTranslation({ localize, enumName, value: this.props.offset })
    } else {
      text = getEnumTranslation({ localize, enumName: 'DueDateWeekly', value: DueDateWeekly.OFFSET }).replace('#', this.props.offset)
    }
    return this.renderReadOnlyText(text)
  }
}

export default EnumBasePicker



// WEBPACK FOOTER //
// ./src/components/Editors/EnumBasePicker.js